import React from "react";
import {
    FormLayout,
    HeaderActions,
    Heading,
    Input,
    LoadingProgress,
    Panel,
    Text,
} from "@/ui";
import { Icon } from "@/components";
import useMeta from "../../base/hooks/useMeta";
import useForm from "../../base/hooks/form/useForm";
import useFormActions from "../../base/hooks/form/useFormActions";
import {
    MUTATION_UPDATE_BLINDDATA_APP,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import useValidator from "../../base/hooks/form/useValidator";
import styles from "./GeneralsForm.module.scss";

const SaveIcon = () => <Icon icon="save" />;

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const BlindDataForm = ({ app }) => {
    const { user } = useMeta();
    const { inputs, setInputs, inputChange } = useForm();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    let options = {
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
            input: {
                ...inputs,
                type: "BlindData",
            },
        },
    };

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "access_code",
                method: "isEmpty",
                validWhen: false,
                message: "This Access Code is required.",
            },

            {
                field: "company_name",
                method: "isEmpty",
                validWhen: false,
                message: "This Company Name is required.",
            },

            // {
            //     field: "sub_account_code",
            //     method: "isEmpty",
            //     validWhen: false,
            //     message: "This Sub Account Code is required.",
            // },
        ],
        {
            ...inputs,
        },
    );

    const { createOrUpdate, loading } = useFormActions(
        "id",
        "Blinddata",
        "",
        MUTATION_UPDATE_BLINDDATA_APP,
        [
            {
                query: QUERY_LIST_STORE_APPS,
                variables: {
                    account_id: user.accountId,
                    store_id: user.storeId,
                },
                skip: user.loading || !user.accountId || !user.storeId,
            },
        ],
        options,
        "",
        isValid,
        isSubmited,
        "primary",
    );

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>Blinddata</Heading>
                        <Text tone="secondary" variant="body-sm">
                            Blinddata Information
                        </Text>
                    </div>
                    <HeaderActions
                        actions={[
                            {
                                id: "update",
                                label: "Update",
                                icon: loading ? undefined : <SaveIcon />,
                                loading,
                                disabled: loading,
                                onClick: () => createOrUpdate(),
                            },
                        ]}
                        aria-label="Blinddata actions"
                    />
                </div>
            }
            showHeaderDivider
        >
            {user.loading ? (
                <div className={styles.loading}>
                    <LoadingProgress
                        indeterminate
                        indicator="circular"
                        size="sm"
                        title="Loading"
                    />
                </div>
            ) : (
                <FormLayout>
                    <FormLayout.Section title="Information">
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(validator, "company_name")}
                                fullWidth
                                label="Company Name"
                                name="company_name"
                                onChange={inputChange}
                                value={inputs.company_name || ""}
                            />
                            <Input
                                error={fieldError(validator, "access_code")}
                                fullWidth
                                label="Access Code"
                                name="access_code"
                                onChange={inputChange}
                                value={inputs.access_code || ""}
                            />
                            <Input
                                fullWidth
                                label="Sub Account Code"
                                name="sub_account_code"
                                onChange={inputChange}
                                value={inputs.sub_account_code || ""}
                            />
                        </FormLayout.Grid>
                    </FormLayout.Section>
                </FormLayout>
            )}
        </Panel>
    );
};

export default BlindDataForm;
